const scene = "portion/";

export const UPDATE_PORTION = `${scene}UPDATE_PORTION`;
export const UPDATE_FILTER = `${scene}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${scene}UPDATE_REDUCER`;
